export default "__VITE_ASSET__UG$y0mFY__"